import { userRoles } from '@constants/common';

const OfficeRoute = {
  path: '/office',
  load: () => import('./Office'),
  protected: true,
};

const OfficeDetailRoute = {
  path: '/office/details/:id?',
  load: () => import('./officeDetails'),
  protected: true,
  roles: [
    userRoles.ADMIN,
    userRoles.ADMIN_LITE,
    userRoles.RECRUITER,
    userRoles.MANAGER,
  ],
};

export { OfficeDetailRoute, OfficeRoute };
